/* global CE2 */

/**
 * Crazy egg plugin
 * @link https://getanalytics.io/plugins/crazyegg
 * @link https://help.crazyegg.com/article/43-crazy-egg-manual-installation
 * @param {object} pluginConfig - Plugin settings
 * @param {string} pluginConfig.accountNumber - crazy egg account ID
 * @return {AnalyticsPlugin}
 * @example
 *
 * // This will load crazy egg on to the page
 * crazyEgg({
 *   accountNumber: '1234578'
 * })
 */
function crazyEgg() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    name: 'crazy-egg',
    config: pluginConfig,
    initialize: function initialize(_ref) {
      var config = _ref.config;
      var accountNumber = config.accountNumber;

      if (!accountNumber) {
        throw new Error('No crazy egg accountNumber defined');
      }

      var _document = document,
          location = _document.location;
      var https = location.protocol === 'https:' || location.protocol === 'chrome-extension:';
      var path = "".concat(accountNumber.slice(0, 4), "/").concat(accountNumber.slice(4));
      var bustCache = Math.floor(new Date().getTime() / 3600000);
      var prefix = https ? 'https:' : 'http:';
      var src = "".concat(prefix, "//script.crazyegg.com/pages/scripts/").concat(path, ".js?").concat(bustCache); // Create script & append to DOM

      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = src; // On next tick, inject the script

      setTimeout(function () {
        var firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      }, 0);
    },
    loaded: function loaded() {
      return !!window.CE2;
    }
  };
}

/* This module will shake out unused code + work in browser and node 🎉 */

var index = crazyEgg ;

export { index as default };
